import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import {LoginPageComponent} from './login-page.container';
import {LoginFormComponent} from './login-form/login-form.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule } from '@ngx-translate/core';


export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n', '.json');
}

@NgModule({
  imports: [SharedModule, TranslateModule.forRoot()],
  declarations: [LoginPageComponent, LoginFormComponent],
  exports: [LoginPageComponent],
  providers: [
    AuthGuard,
    AuthService
  ]
})
export class UserModule {}



// WEBPACK FOOTER //
// ./src/app/users/user.module.ts